var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex flex-wrap justify-center"},_vm._l((_vm.cars),function(car,index){return _c('car-tile',{key:((car.id) + "-" + index),attrs:{"car":car}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }